import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=0d03d304&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=0d03d304&prod&lang=scss&scoped=true&"
import style1 from "./DataTable.vue?vue&type=style&index=1&id=0d03d304&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d03d304",
  null
  
)

export default component.exports